export const contactus = {
    tel: 'โทร',
    day: 'วันจันทร์ - วันศุกร์',
    time: 'เวลา 08.30 - 16.30 น.',
    or: 'หรือ',
}
